import React from "react";
import { useAppSelector } from "store/hooks";
import { selectUser } from "slices/userSlice";
import {
  Box,
  Grid,
  Card,
  CardHeader,
  Divider,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { IDataRowProps } from "ka-table/props";
import { getRoleName } from "src/utilities/helper";

const DetailsRow: React.FC<IDataRowProps> = ({ rowData }) => {
  const details = useAppSelector(selectUser).List.find(
    (item) => item.id === rowData.id
  );

  return (
    <Grid sx={{ marginBottom: "1vh" }}>
      <Card>
        <CardHeader sx={{ ml: 2 }} title={details!.userIdentifier} />
        <Divider />
        <Box p={4} sx={{ display: "flex" }}>
          <Table sx={{ width: "50%", marginRight: "10vh" }}>
            <TableBody>
              <TableRow>
                <TableCell style={{ borderBottom: "none" }}>
                  <Typography variant="subtitle1">Name:</Typography>
                </TableCell>
                <TableCell style={{ borderBottom: "none" }}>
                  {details!.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ borderBottom: "none" }}>
                  <Typography variant="subtitle1">Role:</Typography>
                </TableCell>
                <TableCell style={{ borderBottom: "none" }}>
                  <Typography>{getRoleName(details!.role)}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Card>
    </Grid>
  );
};

export default DetailsRow;
